import { render } from "./SearchingBox.vue?vue&type=template&id=2f2f4e74&scoped=true"
import script from "./SearchingBox.vue?vue&type=script&lang=js"
export * from "./SearchingBox.vue?vue&type=script&lang=js"

import "./SearchingBox.vue?vue&type=style&index=0&id=2f2f4e74&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2f2f4e74"]])

export default __exports__